var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1909 1.01291C11.9436 0.953607 11.6673 1.01976 11.4781 1.21014L1.8318 10.9128C1.78568 10.9574 1.75098 11.0124 1.73056 11.0733L0.229501 15.5887C0.198652 15.6829 0.204007 15.7852 0.244302 15.8758C0.284675 15.9663 0.357161 16.0387 0.447841 16.0788C0.538462 16.1189 0.640777 16.1239 0.734954 16.0929L5.22976 14.5797C5.28788 14.5605 5.34083 14.5282 5.38447 14.4853L15.0307 4.78261C15.3191 4.49254 15.3193 4.01203 15.0304 3.72137L12.5392 1.20969C12.467 1.13702 12.3824 1.08253 12.2918 1.04634C12.2579 1.03273 12.2262 1.02127 12.1908 1.01281L12.1909 1.01291ZM12.0092 1.81185L14.4302 4.24642L13.0037 5.68247L10.5826 3.2479L12.0092 1.81185ZM10.0184 3.80829L12.4378 6.24898L5.10163 13.6332L2.67446 11.197L10.0184 3.80829ZM2.28922 11.9347L4.36734 14.0315L1.24481 15.0842L2.28922 11.9347Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.458a03c70dc11740e9582286b1ecf80b.svg";
export { ForwardRef as ReactComponent };